import React, { useState, useEffect } from 'react';
import API from 'utils/API';
import ReactStrapTable from 'components/reactStrapTable';
import { dateFormate, cellRendererCheck, fileFormatter } from 'utils/columns';

const PatientComment = (props) => {
  const { tenantID, coveredEntityID, text = 'Patient Comment' } = props;
  const [loading, setLoading] = useState(false);
  const patientID = parseInt(props.patientID);
  const [data, setData] = useState([]);

  const fetchPatientComments = async () => {
    setLoading(true);
    try {
      const { data } = await API.get(
        `/${tenantID}/Comments/PatientComments/${patientID}`
      );
      setLoading(false);
      setData(data);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPatientComments();
  }, []);

  const download = async (file) => {
    const { fileRepositoryID } = file;
    try {
      const { access_token } =
        JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
      setLoading(true);
      const res = await API.get(
        `/${tenantID}/Comments/Download/${parseInt(
          coveredEntityID
        )}/${fileRepositoryID}?access_token=${access_token}`,
        {
          responseType: 'blob',
        }
      );
      setLoading(false);
      if (res.request.responseType === 'blob') {
        window.open(res.request.responseURL);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const columns = [
    {
      dataField: 'comments',
      text: text,
      width: 180,
    },
    {
      dataField: 'createdDate',
      text: 'Created Date',
      width: 60,
      cellRenderer: (row) => dateFormate(row.createdDate),
    },
    {
      dataField: 'createdBy',
      text: 'Created By',
      width: 60,
      cellRenderer: (row) => cellRendererCheck(row.createdBy),
    },
    {
      dataField: 'files',
      text: 'Attachments',
      width: 100,
      cellRenderer: (row) => fileFormatter(row, download),
    },
  ];

  return (
    <ReactStrapTable
      id='commnets'
      height={50 * data.length}
      columns={columns}
      data={data}
      loading={loading}
    />
  );
};

export default PatientComment;
